// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_tw-0";